<template >
    <div id="comMbManage">
        <div class="mybreadcrumb">
            <div style="display:flex;align-items:center">
                <i class="iconfont icon-qiye-tianchong" style="margin-right:10px;color:#999"></i>
                <el-breadcrumb separator-class="el-icon-arrow-right" >
                    <el-breadcrumb-item>企业管理</el-breadcrumb-item>
                    <el-breadcrumb-item>部门 / 成员管理</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div  style="display:flex;align-items: flex-start">
            <departmentTree
                class="mydepartmentTree"
                @refreshUser="refreshUser">
            </departmentTree>
            <div v-loading="memberloading" element-loading-text="数据加载中..." style="width:100%" id="mybar">
                <div class="menberoperate-box">
                    <!-- <span style="margin-left:30px">所有成员({{tableData.length}})</span> -->
                    <div class="operate-right">
                        <el-input placeholder="手机号/姓名" 
                        size="medium"
                        style="width:210px;margin:10px 10px 10px 10px"
                        v-model.trim="queryParams.searchCondition"
                        @keyup.enter.native="searchUser">
                            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor:pointer" @click="searchUser"></i>
                        </el-input>
                            <div style="display:flex;margin-left:10px;flex-wrap:wrap">

                                <!-- <el-button  type="primary" class="operate-btn" @click="addMemberClick">邀请成员</el-button> -->
                                <el-dropdown  trigger="hover" style="margin-right:10px">
                                    <el-button  type="primary" class="operate-btn" id="downloadSoft">邀请成员</el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item >
                                            <div @click="addMemberClick">逐个/批量短信邀请</div>
                                        </el-dropdown-item>
                                        <el-dropdown-item >
                                            <div @click="shareBtnclick">分享链接/二维码</div>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>



                                <el-button  class="operate-btn" @click="applyBtnClick">成员申请</el-button>
                                <el-button  class="operate-btn" :disabled="deletelength" @click="removeMemberClick">移动成员</el-button>

                                <el-dropdown style="margin-left:10px" trigger="hover">
                                    <div class="morebtn">更多</div>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item :disabled="deletelength">
                                            <div @click="deleteMember">删除成员</div>
                                        </el-dropdown-item>
                                        <el-dropdown-item >
                                            <div @click="returnClick">查看邀请记录</div>
                                        </el-dropdown-item>
                                        
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                    </div> 
                </div>
                <div style="">
                    <div style="width:100%;padding:0 10px">
                        <el-table
                            :data="tableData"
                            border
                            :header-cell-style="{color:'#333333',fontFamily:'MicrosoftYaHei',fontSize:'12px',fontWeight:400,padding:'9px 0',background:'#F5F5F5'}"
                            style="width: 100%"
                            :cell-class-name="tabCellClassName"
                            @selection-change="handleSelectionChange"
                            @cell-dblclick="memberscelldbclick">
                            <el-table-column
                            type="selection"
                            width="55"
                            align="center">
                            </el-table-column>
                            <el-table-column
                                    label="序号"
                                    type="index"
                                    width="60"
                                    align="center"
                                    >
                                <template slot-scope="scope">
                                        <span>{{scope.$index + 1}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="phonenum"
                            label="手机号"
                            show-overflow-tooltip
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="username"
                            label="姓名/企业昵称"
                            show-overflow-tooltip
                            align="center">
                                <template slot-scope="scope">
                                        <span v-show="!scope.row.usernameedit">{{scope.row.username}}</span>
                                            <el-input
                                                v-show="scope.row.usernameedit"
                                                :ref="'usernameedit'+scope.$index"
                                                size="small"
                                                v-model.trim="scope.row.username"
                                                @blur="menberseditblur(scope.$index,scope.row,'usernameedit')"
                                                placeholder=""
                                                maxlength="10"
                                            ></el-input>
                                    </template>
                            </el-table-column>
                            <el-table-column
                            prop="bumen"
                            label="部门"
                            show-overflow-tooltip
                            align="center">
                                <template slot-scope="scope">
                                    <span>{{scope.row.bumen}}</span>
                                        <!-- <span v-show="!scope.row.bumenedit">{{scope.row.bumen}}</span> -->
                                            <!-- <el-input
                                                v-show="scope.row.bumenedit"
                                                :ref="'bumenedit'+scope.$index"
                                                size="small"
                                                v-model.trim="scope.row.bumen"
                                                @blur="menberseditblur(scope.$index,scope.row,'bumenedit')"
                                                placeholder=""
                                            ></el-input> -->
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="addedAt"
                            label="加入时间"
                            show-overflow-tooltip
                            align="center"
                            >
                            </el-table-column>
                        </el-table>

                        <el-pagination
                        style="padding:20px 0"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage1"
                        :page-sizes="[10, 20, 30]"
                        :page-size="10"
                        layout="total,sizes, prev, pager, next"
                        :total="total">
                        </el-pagination>

                    </div>
                </div>
            </div>
        </div>


        <el-dialog
            title="移动到"
            :visible.sync="userMoveDialogVisible"
            width="500px"
            :close-on-click-modal="false">
            <menberMoveTree
            ref="menberMoveTree"
            @closeMoveDialog="closeMoveDialog"
            @ConfirmMoveDialog="ConfirmMoveDialog">
            </menberMoveTree>
        </el-dialog>

        <el-dialog
            v-if="shareinviteDialogVisible"
            title="邀请成员"
            ref="shareInviteinfo"
            :visible.sync="shareinviteDialogVisible"
            width="700px"
            :close-on-click-modal="false">
            <shareInviteinfo>

            </shareInviteinfo>
        </el-dialog>


    </div>
</template>

<script>
let elementResizeDetectorMaker = require("element-resize-detector");
import Driver from 'driver.js' // import driver.js
import 'driver.js/dist/driver.min.css' // import driver.js css
import steps from './components/inviteStep.js'
import {getUserInfo,
        InviteSingleUser,
        UserList,
        GetEnterpriseUserListApi,
        DeleteEnterpriseUser,
        ChangeAdmin,
        BatchDeleteEnterpriseUsers,
        InviteUserList,
        InviteMultipleUser,
        DownLoadTemplateApi,
        EditUsersInfoByPhoneApi,
        EditUserConnectionNameAndDepartmentApi,
        GetUsersRealNameByPhoneApi,
        UpdateEnterpriseInfoAndUserListApi,
        GetNotificationsRecordApi,
        CreateNotificationsRecordApi,
        GetEnterpriseUserStatusApi,
        enterPriseDetailInfo
    } from '@/js/enterPriseApi'
import Moment from 'moment'
import Vue from 'vue'
import {BASE_URL} from "../../../../config/env";
import {MyZhugeTrackGoMember,
MyZhugeTrackCkAddBtutton,
MyZhugeTrackCkSeeInviteHis,
MyZhugeTrackCkDLTemplate,
MyZhugeTrackCkCVTemplate,
MyZhugeTrackCkAddConfirm,
MyZhugeTrackDepMgMoveMember,
MyZhugeTrackDepMgDeleteMember} from '@/js/zhugemaidian.js'
import { updateUserInfoApi } from '../../../js/api';
import {mydebounce} from '@/js/common.js'
import departmentTree from '@/view/CompanyUser/companyManage/departmentTree'
import menberMoveTree from '@/view/CompanyUser/companyManage/menberMoveTree'
import shareInviteinfo from '@/view/CompanyUser/companyManage/shareInviteinfo'
export default {
    name:'MemberManage',
    components:{
        departmentTree,
        menberMoveTree,
        shareInviteinfo
    },
    data(){
        var checkPhone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号不能为空'));
        } else {
          const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('请输入正确的手机号'));
          }
        }
      };
        return{
            ZhugeTrackenterpriseName:'',
            shareinviteDialogVisible:false,//分享邀请信息弹窗开关
            memberloading:false,
            userMoveDialogVisible:false,//成员数据移动dialog
            companypic:require('../../../assets/img/wxzfbpay/phone.png'),
            tanpng:require('../../../assets/img/companyuserpng/tanhao.png'),
            copytextarea:'',
            tipsDialogVisible:false,
            tableData: [],//展示企业的所有成员
            multipleSelection: [],
            dialogtableData:[{
                'realName':'',
                'phone':'',
                'department':'',
                'departmentedit':false,
                'phoneedit':false,
                'realNameedit':false,
                }
            ],
            formLabelAlign: {
                telephone: '',
                realName: '',
                department: ''
            },
            rules: {
                telephone:[
                    {required:true,validator: checkPhone, trigger: 'blur'}
                ],
                },
            dialogVisible:false,
            activeName: 'first',
            excelUserInfo:[],
            currentdepid:'',//当前部门id,由子组件传递而来
            currentPage1:1,
            total:0,
            hasPreviousPage:false,
            queryParams:{
                pageSize:10,
                pageIndex:0,
                searchCondition:''
            },
            driver:null,
            steps : [
                {
                element: '#downloadSoft',
                popover: {
                    title: ' ',
                    description: '<div style="padding:40px 90px 20px 90px;display:flex" ><i class="iconfont icon-yijianfankui" style="color:#35B065;font-size:40px;padding-right:15px"></i> <div><div style="padding-top:0px;font-family: MicrosoftYaHei;font-size: 18px;color: #333333;">亲爱的用户，为保障您信息的安全性，我们对邀请企业成员的方式进行了优化升级！</div>   <div style="font-family: MicrosoftYaHei;margin-top:36px;font-size: 14px;color: #333333;"><div>包括以下两种邀请方式：</div><div style="margin-top:15px">1、输入/导入用户信息邀请，待用户确认后，成功加入；</div><div style="margin-top:10px">2、用户打开管理员分享的链接或扫描二维码，填写申请信息后提交，待管理员审核通过后，成功加入。</div></div>  <div style="font-family: MicrosoftYaHei;font-size: 18px;color: #333333;margin-top:36px">快去体验吧！</div> <div style="display:flex;justify-content:center;margin-top:15px;"><div style="width: 80px;height: 34px;background: #0069e0;border-radius: 2px;cursor:pointer;line-height:34px;text-align:center;color:#fff" id="haha" onclick="clickFun()">了解详情</div></div></div></div>',
                    position: 'bottom-right',
                    prevBtnText: '重新演示'
                }
                },
                
            ]
           
        }
    },
    computed:{
        selectedlength(){
            if(this.multipleSelection.length===1){
                return false;
            }else{
                return true;
            }
        },
        deletelength(){
            if(this.multipleSelection.length>=1){
                return false;
            }else{
                return true;
            }
        },
        dialogtableDatalength(){
            return this.dialogtableData.length
        }
    },
    created(){
        this.getCompanyName()
    },
    mounted(){
        MyZhugeTrackGoMember();//诸葛埋点 
        //成员列表自适应宽度 
        let erd = elementResizeDetectorMaker();
        let that = this;
        erd.listenTo(document.getElementsByClassName('mydepartmentTree')[0], function (element) {
            that.$nextTick(()=>{
                let allClientWidth=document.getElementById('comMbManage').clientWidth
                document.getElementById('mybar').style.width=allClientWidth-element.clientWidth+'px'
            })
        })
        
        this.GetNotificationsRecord()
        
    },
    methods:{
        getCompanyName(){
            let that=this;
                let params={
                    enterPriseId:window.localStorage.getItem('enterPriseId')
                };
                enterPriseDetailInfo(params)
                .then(res=>{
                    if(res.status===200 && res.data.error_code===0){
                        const {data}=res.data;
                        that.ZhugeTrackenterpriseName=data.enterpriseName;
                    }else{
                        this.$message.error(res.data.error_msg)
                    }
                })  
                .catch(err=>{
                    if(err.data && err.data.errorMessages){
                        that.$message.error(err.data.errorMessages[0]);
                    }else if(err.data){
                        that.$message.error(err.data)
                    }
                })
        },
        GetNotificationsRecord(){
            let that=this
            GetNotificationsRecordApi({
                recordType:1
            })
            .then(res=>{
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    if(data.length==0){
                        //判断是超级管理员，需要引导提示
                        if(this.$store.state.isSuperAdminUser){
                            this.guide()
                        }
                    }
                }else{
                    that.memberloading=false;
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        handleClicknotice(){//关闭引导提示例，调用接口。
            let that=this
            CreateNotificationsRecordApi({
                recordType:1
            })
            .then(res=>{
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    console.log(data)
                }else{
                    that.memberloading=false;
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
            
        },
        guide(callbacks){
            this.driver = new Driver({
                doneBtnText: "知道了", // 结束按钮的文字
                allowClose: false, // 是否可以通过点击遮罩层关闭指引
                stageBackground: "#fff", // 突出显示元素的背景颜色
                nextBtnText: "下一步", // 下一步按钮的文字
                prevBtnText: "上一步", // 上一步按钮的文字
                closeBtnText: "关闭", // 关闭按钮的文字
                keyboardControl: false, // 是否允许键盘操控
                xCloseButton: true, // 将关闭按钮作为X放在弹出
                onReset: ele => {
                    this.handleClicknotice()
                }, // 关闭 跳过
            })
            this.driver.defineSteps(this.steps)
            this.driver.start()
            this.$nextTick(()=>{
                window.clickFun = this.clickFun;
            })
            
        },
        clickFun(){
            window.open('http://doc.pkpm.cn/docs/glyzh_wb','_blank')
        },
        shareBtnclick(){//分享链接或二维码按钮点击
            MyZhugeTrackCkAddBtutton({
                "企业名称":this.ZhugeTrackenterpriseName,
                "邀请方式":'分享链接/二维码'
            })
            this.shareinviteDialogVisible=true
        },
        refreshUser(depid){
            this.currentdepid=depid
            this.getUserList(); 
        },
        searchUser :mydebounce(function(){//搜索成员
            this.queryParams.pageIndex=0

            this.getUserList()
        },500),
        closeMoveDialog(){//关闭弹窗回调
            this.userMoveDialogVisible=false
        },
        ConfirmMoveDialog(dialogdepid){//确认弹窗回调，移动部门成员
            let that=this
            MyZhugeTrackDepMgMoveMember({
                "企业名称":that.ZhugeTrackenterpriseName,
            })

            console.log(dialogdepid)
            this.userMoveDialogVisible=false
            this.UpdateEnterpriseInfoAndUserList(dialogdepid)
        }, 
        UpdateEnterpriseInfoAndUserList(dialogdepid){
            let that=this;
            let arr=[];
            this.multipleSelection.forEach(item=>{
                arr.push(item.userId);
            })
            let params={
                enterPriseId:window.localStorage.getItem('enterPriseId'),
                editEnterpriseDepartmentId:dialogdepid
            }
            that.memberloading=true
            UpdateEnterpriseInfoAndUserListApi(params,arr)
            .then(res=>{
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    this.$message.success('成员移动成功！')
                    that.memberloading=false;
                    this.getUserList()
                }else{
                    that.memberloading=false;
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                that.memberloading=false;
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })

        
        },
        changeEdit(index,rowdata,type){//双击事件
            this.dialogtableData[index][type]=!this.dialogtableData[index][type];
            setTimeout(()=>{
                this.$refs[type+index].focus()
            },1)
        },
        menberseditblur(index,rowdata,type){
            console.log(index,rowdata,type)
            
            this.tableData[index][type]=!this.tableData[index][type];
            this.tableData=[...this.tableData];

            if(type=='usernameedit'||type=='bumenedit'){
                this.updateUserInfo(index,rowdata,this.tableData[index].phonenum)
            }

        },
        updateUserInfo(index,rowdata,phone){//更新成员信息
            let that=this;
            console.log(index,rowdata,phone)
            if(!rowdata.username){
                this.$message.warning('将姓名补充完整后即可更新')
                return 
            }

            let paraobj={
                "enterpriseId":window.localStorage.getItem('enterPriseId'),
                "editEnterpriseUserRealNameAndDeptRequests": [
                    {
                        "phone":phone,
                        "realName":rowdata.username?rowdata.username:' ',
                        "department":rowdata.bumen?rowdata.bumen:'',
                        'enterpriseDepartmentId':rowdata.enterpriseDepartmentId
                    }]
                    
            }
            EditUserConnectionNameAndDepartmentApi(paraobj)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                        if(res.data.data===true){
                            that.$message.success("成员信息更新成功")
                        }else{
                            this.$message.error(res.data.error_msg)
                        }
                    }else{
                        this.$message.error(res.data.error_msg)
                    }
            })
            .catch(err=>{
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        
        tabCellClassName({row, column, rowIndex, columnIndex}){
            return 'cellstyle'
        },
        
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleSizeChange(val){//条数切换
            this.queryParams.pageSize=val
            this.getUserList();
        },
        handleCurrentChange(val){//页数切换
            console.log(`当前页: ${val}`);
            this.queryParams.pageIndex=val

            this.getUserList();
        },
        celldbclick(row, column,cell){//表格行双击事件
            console.log(row,column)
            this.dialogtableData[row.index][column.property+'edit']=!this.dialogtableData[row.index][column.property+'edit'];
            setTimeout(()=>{
                this.$refs[column.property+'edit'+row.index].focus()
            },1)
        },
        memberscelldbclick(row, column,cell){//获取成员列表页表格行双击事件
            //console.log(row,column)
            if(column.property==='phonenum'){
                return
            }
            if(column.property==='bumen'){
                return
            }
            this.tableData[row.index][column.property+'edit']=!this.tableData[row.index][column.property+'edit'];
            setTimeout(()=>{
                this.$refs[column.property+'edit'+row.index].focus()
            },1)
        },
        tableRowClassName({row,rowIndex}){
            row.index=rowIndex
        },
        getUsersRealName(){//批量获取成员真实姓名
            let that=this;
            if(that.excelUserInfo.length==0){
                return 
            }
            let phonelist=[];
            that.excelUserInfo.forEach(item=>{
                phonelist.push(item.phone)
            })
            GetUsersRealNameByPhoneApi({
                "enterpriseId":window.localStorage.getItem('enterPriseId'),
                 "phonelist":phonelist
            })
            .then(res=>{
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    for(let i=0;i<data.length;i++){
                        // debugger
                        // let tableindex=ExcelIndex[i];
                        // that.dialogtableData[tableindex]['realName']=data[i].realName;
                        that.dialogtableData.forEach((item,index)=>{
                            if(item.phone==data[i].phone){
                                that.dialogtableData[index]['realName']=data[i].realName;
                            }
                        })
                    }

                }else{
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })

        },
        returnClick(){
            let that=this;
            this.$router.push('/seeInviteHis')
        },
        applyBtnClick(){
            this.$router.push('/seeMemberApply')
        },
        filterTag(value, row) {//表格筛选
            
            return row.inviteStatus === value;
        },
        getUserList(){//获取企业成员列表
            let that=this;
            let params={
                enterPriseId:window.localStorage.getItem('enterPriseId'),
                enterpriseDepartmentId:this.currentdepid,
                pageIndex:this.queryParams.pageIndex,
                pageSize:this.queryParams.pageSize,
                searchCondition:this.queryParams.searchCondition
            }
            this.memberloading=true
            GetEnterpriseUserListApi(params)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                    const {data}=res.data;
                    that.tableData=[];
                    this.total=0;
                    this.total=data.totalItems
                    that.hasPreviousPage=data.hasPreviousPage;
                    data.list.forEach((item,index)=>{
                        let obj={
                            bumen:item.department,
                            phonenum:item.phone,
                            username:item.realName,
                            userId:item.userId,
                            enterpriseDepartmentId:item.enterpriseDepartmentId,
                            bumenedit:false,
                            usernameedit:false,
                            index:index,
                            addedAt:item.addedAt?Moment(item.addedAt).format("YYYY-MM-DD HH:mm:ss"):''
                        }
                        that.tableData.push(obj);
                    })
                    this.memberloading=false
                }else{
                    this.memberloading=false
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                this.memberloading=false
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        deleteMember(){//删除成员按钮点击
            let that=this;
            if(!this.multipleSelection.length)
            return 
            this.$confirm('所选用户下所有企业产品授权将被收回，确定要删除所选用户吗？', '提示信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'message-logout'
                }).then(() => {
                    MyZhugeTrackDepMgDeleteMember({
                        "企业名称":that.ZhugeTrackenterpriseName,
                    })
                    if(that.multipleSelection.length===1){
                        //this.deleteUser();
                        mydebounce(that.deleteUser,600)();
                    }else{
                        //this.deleteMultiUsers();

                        mydebounce(that.deleteMultiUsers,600)();
                    }
                }).catch(() => {  
            });
        },
        deleteUser(){//先删除单个用户
            let that=this;
            console.log(that.multipleSelection);
            let passportToken=window.localStorage.getItem('passportToken')
            let passportTokenModify=passportToken.split('Bearer ')[1];

            that.memberloading=true
            DeleteEnterpriseUser({
                enterPriseId:window.localStorage.getItem('enterPriseId'),
                userId:that.multipleSelection[0].userId,
                passportToken:passportTokenModify
            })
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                        if(res.data.data===true){
                            that.$message.success("成员删除成功")
                            
                            if(this.multipleSelection.length==that.tableData.length){
                                if(that.hasPreviousPage===true){
                                    that.queryParams.pageIndex=that.queryParams.pageIndex-1;
                                }else{
                                    that.queryParams.pageIndex=0;
                                }
                            }else{
                                that.queryParams.pageIndex=that.queryParams.pageIndex
                            }

                            that.getUserList();
                        }else{
                            that.memberloading=false
                            this.$message.error(res.data.error_msg)
                        }
                    }else{
                        that.memberloading=false
                        this.$message.error(res.data.error_msg)
                    }
            })
            .catch(err=>{
                that.memberloading=false
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    
                    that.$message.error(err.data);
                    
                }
            })

        },
        deleteMultiUsers(){//批量删除用户
            let that=this;
            let arr=[];
            this.multipleSelection.forEach(item=>{
                arr.push(item.userId);
            })
            let passportToken=window.localStorage.getItem('passportToken')
            let passportTokenModify=passportToken.split('Bearer ')[1];
            let params={
                enterPriseId:window.localStorage.getItem('enterPriseId'),
                passportToken:passportTokenModify
            }
            that.memberloading=true
            BatchDeleteEnterpriseUsers(params,arr)
            .then(res=>{
                console.log(res)
                if(res.status===200 && res.data.error_code===0){
                        if(res.data.data===true){
                            that.$message.success("成员删除成功")
                            
                            if(this.multipleSelection.length==that.tableData.length){
                                if(that.hasPreviousPage===true){
                                    that.queryParams.pageIndex=that.queryParams.pageIndex-1;
                                }else{
                                    that.queryParams.pageIndex=0;
                                }
                            }else{
                                that.queryParams.pageIndex=that.queryParams.pageIndex
                            }

                            that.getUserList();
                        }else{
                            that.memberloading=false
                            this.$message.error(res.data.error_msg)
                        }
                    }else{
                        that.memberloading=false
                        this.$message.error(res.data.error_msg)
                    }
            })
            .catch(err=>{
                that.memberloading=false
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })

        },
        removeMemberClick(){//移动成员按钮点击
            //先调用接口
            let that=this
            let reqdata={
                enterPriseId:window.localStorage.getItem('enterPriseId'),
                getEnterpriseUserStatusDtos:[]
            }
            this.multipleSelection.forEach(ele=>{
                let obj={
                    enterpriseDepartmentId:ele.enterpriseDepartmentId,
                    userId:ele.userId
                }
                reqdata.getEnterpriseUserStatusDtos.push(obj)
            })
            GetEnterpriseUserStatusApi(reqdata)
            .then(res=>{
                if(res.status===200 && res.data.error_code===0){
                        let depstatus=res.data.data
                        console.log(depstatus)
                        if(depstatus===0){//该成员不是子管理员，和该成员没有本部门产品授权
                            this.moveMenberFun()
                        }else{
                            this.moveConfirmTip(depstatus)//做相应的提示
                        }
                }else{
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })
        },
        moveConfirmTip(depstatus){
            let tip=""
                if(depstatus===1){
                    tip='有成员下有本部门授权，移动时会收回，确定要移动吗？'
                }else if(depstatus===2){
                    this.$message.error('有成员是管理员，不允许移动!')
                    return 
                }else if(depstatus===3){//三种情况都有 即有授权、又是部门的子管理员
                    this.$message.error('有成员是管理员，不允许移动!')
                    return 
                }
                this.$confirm(tip, '提示信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    customClass: 'message-logout'
                }).then(() => {
                    this.moveMenberFun()
                })
                .catch(() => {  
                });
        },
        moveMenberFun(){
            this.userMoveDialogVisible=true
            this.$nextTick(()=>{
                this.$refs.menberMoveTree.GetEnterpriseDepartment({
                    enterpriseId:localStorage.getItem('enterPriseId'),
            })
            })
        },
        addMemberClick(){//邀请成员按钮点击
            MyZhugeTrackCkAddBtutton({
                "企业名称":this.ZhugeTrackenterpriseName,
                "邀请方式":'逐个/批量短信邀请'
            })
            this.$router.push('/inviteUser')
        },
        changeAdminClick(){//移交管理员按钮点击
            this.$confirm('确认将管理员权限移交该用户吗？', '提示信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'message-logout'
                }).then(() => {
                    this.changeAdminConfirm()
                }).catch(() => {  
            });
        },
        changeAdminConfirm(){//移交管理员，弹窗确定按钮点击
            let that=this;
            ChangeAdmin({
                enterPriseId:window.localStorage.getItem('enterPriseId'),
                newAdminUserId:that.multipleSelection[0].userId
            })
            .then(res=>{
                console.log(res);
                if(res.status===200 && res.data.error_code===0){
                        if(res.data.data===true){
                            window.localStorage.removeItem('enterPriseId')
                            that.$store.commit("setCurrentCompany","个人")
                            that.$message.success("管理员移交成功")
                            that.$router.push('/personalMainPage')
                        }else{
                            this.$message.error(res.data.error_msg)
                        }
                    }else{
                        if(res.data.error_msg.indexOf("该用户已经是企业")!=-1){
                            this.$message.error("该用户已经是其他企业管理员！")
                        }else{
                            this.$message.error(res.data.error_msg)
                        }
                    }
            })
            .catch(err=>{
                console.log(err)
                if(err.data && err.data.errorMessages){
                    that.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    that.$message.error(err.data);
                }
            })

        },
   
    }

}
</script>
<style lang="scss" scoped>
    #comMbManage{
        background: #fff;
        min-height: 100%;
        /deep/ .el-breadcrumb{
            .el-breadcrumb__inner{
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #666666;
                font-weight: 400;
            }
            .el-breadcrumb__separator{
                font-size: 12px !important;
                color: #666666;
            }
        }
        .mybreadcrumb{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 13px 0 13px 20px;
            border-bottom: 1px solid #EAEAEA;
            .return-button{
                margin-right: 20px;
                width: 120px;
                height: 30px;
                background: #F6F6F6;
                border: 1px solid #E0E0E0;
                border-radius: 2px;
                line-height: 30px;
                cursor: pointer;
            }
            
        }
        .menberoperate-box{
            width: 100%;
            overflow: hidden;
            position: relative;
            padding: 0 10px 0 0px;
            margin-bottom: 15px;
            margin-top: 20px;
            .operate-right{
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-wrap: wrap;
                .operate-btn{
                    font-size: 14px;
                    padding: 10px ;
                }
                .morebtn{
                    width:80px;
                    height:34px;
                    line-height:34px;
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #333333;
                    border: 1px solid #E0E0E0;
                    border-radius: 2px;
                    cursor: pointer;
                }
            }
            span{
                float: left;
                position: absolute;
                bottom: 0px;
                left: 0px;
                font-family: FZLTZHK--GBK1-0;
                font-size: 14px;
                color: #333333;
                font-weight: 600;
            }
            /deep/ .el-dropdown {
                //padding-right: 18px;
            }
        }
        .table-status{
            span{
                margin-left: 8px;
            }
        }
        .bgcorange::before{
                content:'';
                width: 10px;
                height: 10px;
                border-radius: 50%;
                display: inline-block;
                background: #FE833D;
            }
        .bgcgreen::before{
            content:'';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            display: inline-block;
            background: #1DCB96;
        }
        .form-wraper{
            width: 420px;
            margin: 0 auto;
        }
        .ope-wraper{
            font-size: 16px;
            width: 45px;
            height: 14px;
            line-height: 14px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            .dec-button{
                cursor: pointer;
                width: 14px;
                height: 14px;
                color:#fff;
                background: #888888;
                border-radius: 50%;
            }
            .add-button{
                cursor: pointer;
                width: 14px;
                height: 14px;
                color:#fff;
                background: #3AC49F;
                border-radius: 50%;
            }
            
        }
        .tips-wraper{
            padding: 20px 0 0px 0;
            display: flex;
            justify-content: center;
            align-items: center;
            .tip-text{
                margin-left: 20px;
                margin-right: 25px;
                text-align: left;
            }
        }
        //element-ui样式
        /deep/ .el-table .cellstyle{
            //padding: 10px 0 !important;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #666666;
            font-weight: 400;
            padding: 0;
            height: 40px;//记录
        }
        /deep/ .el-dialog{
            border-radius: 2px;
            width: 1000px;
            .el-dialog__header{
                background: #0069e0;
                text-align: left;
                padding: 15px 20px;
                .el-dialog__title{
                    font-family: MicrosoftYaHei;
                    font-size: 16px;
                    color: #FFFFFF;
                    font-weight: 400;
                }
                .el-dialog__close{
                    color: #fff;
                }
            }
            .el-dialog__body{
                padding: 10px 10px 20px 20px;
                max-height: 490px;
                overflow: hidden;
                overflow-y: auto;
                .el-tabs__nav-wrap{
                    padding-left: 20px;
                }
                .el-form-item__label{
                    padding-right: 12px;
                }
            }
            .rightbtn-wraper{
                margin-left: 15px;
                .btn-comwraper{
                    width: 22px;
                    height: 22px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    margin-right: 10px;
                    cursor: pointer;
                }
            }
        }
        //common样式
        .commonwidth1{
            display: inline-block;
            width: 50px;
        }
        .commonfz14-co99{
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #999999;
            font-weight: 400;
        }
        .commonfz14-co33{
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #333333;
            font-weight: 400;
        }
        .common-matop{
            margin-top: 15px;
        }
        .input-width{
            width: 300px;
            height: 36px;
        }
        
    }
    
</style>
<style lang="scss">
    .button-popper{
                width: 70px !important;
                min-width:70px !important;
                max-width:70px !important;
                padding: 2px 0 !important;
                .ulstyle{
                    text-align: center;
                    li{
                        padding: 3px 0;
                        cursor: pointer;
                    }
                    li:hover{
                        background:#ecf5ff;
                        color:#66b1ff;
                    }
                }
            }
    #driver-popover-item{
        max-width: 800px !important;
    }
</style>


// WEBPACK FOOTER //
// src/view/CompanyUser/companyManage/comMbManage.vue